import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Subject, Subscription } from "rxjs/Rx";
import { BackendService } from "../../shared/services/backend.service";
import { PollService } from "../../shared/services/poll/poll.service";
import { Poll } from "../../shared/services/poll/poll";
import { NgbProgressbarConfig } from "@ng-bootstrap/ng-bootstrap";
import { AccountService } from "../../shared/account/account.service";
import { AuthService } from "../../shared/services/auth.service";

@Component({
  selector: "app-view-poll",
  templateUrl: "./view-poll.component.html",
  styleUrls: ["./view-poll.component.css"]
})
export class ViewPollComponent implements OnInit {
  private routeSubscription: Subscription = new Subscription();
  activeRouteIndex: number;
  polls = [
    {
      id: '1',
      name: 'Poll for Painting Security Gate',
      voteCount: '300',
      dateCreated: '1534002040',
      expiryDate: '1536680440'
    },
    {
      id: '2',
      name: 'Poll for Changing Security Guards',
      voteCount: '100',
      dateCreated: '1534002040',
      expiryDate: '1536680440'
    },
    {
      id: '3',
      name: 'Poll for Road Maintenance',
      voteCount: '30',
      dateCreated: '1534002040',
      expiryDate: '1536680440'
    },
    {
      id: '4',
      name: 'Poll for New App',
      voteCount: '150',
      dateCreated: '1534002040',
      expiryDate: '1536680440'
    },
    {
      id: '5',
      name: 'Poll for New Transformer',
      voteCount: '0',
      dateCreated: '1534002040',
      expiryDate: '1536680440'
    }
  ];
  poll;
  pollId;
  userId;
  communityId;
  pollSubscription;
  options: Array<any>;
  now = Date.now();

  constructor(
    private accountService: AccountService,
    private authService: AuthService,
    private route: ActivatedRoute,
    config: NgbProgressbarConfig,
    private pollService: PollService
    ) {
    config.animated = true;
    config.height = "1.5rem";
    this.userId = BackendService.generateUserId(this.authService.getAuthState().email);
  }

  ngOnInit(): void {
    this.routeSubscription = this.accountService.getProfile(this.userId)
    .subscribe((profile: any) => {
      this.route.params.subscribe(params => {
        this.activeRouteIndex = +params.index;
        const activeRole: any = profile.roles[this.activeRouteIndex];
        this.communityId = activeRole.communityId;
        this.pollId = params.pollId;
        this.pollSubscription = this.pollService.getPollById(this.communityId, this.pollId)
        .subscribe(poll => {
          this.options = Object.keys(poll.options);

          return this.poll = poll;
        });
      });
  });
}
}



// WEBPACK FOOTER //
// ./src/app/polls/view-poll/view-poll.component.ts